module.exports = __webpack_public_path__ + "static/media/angle-right-small.5353dfbb.svg";